import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, alt: String }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const overlay = document.createElement("div")
    overlay.className = "image-lightbox-overlay"
    overlay.innerHTML = `
      <button type="button" class="image-lightbox-close" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
      <img class="image-lightbox-image" src="${this.urlValue}" alt="${this.altValue || ""}">
    `

    const close = () => {
      overlay.remove()
      document.removeEventListener("keydown", onKey)
      document.body.style.overflow = ""
    }

    const onKey = (e) => { if (e.key === "Escape") close() }

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay || e.target.closest(".image-lightbox-close")) close()
    })
    document.addEventListener("keydown", onKey)
    document.body.style.overflow = "hidden"
    document.body.appendChild(overlay)
  }
}
